export const environment = {
  production: false,
  apiBaseUrl: 'https://driversafety-api-qa.azurewebsites.net/api'
};
